import apiClient, { apiClientV2 } from '@/services/rest-api/apiClient'
let baseURL = process.env.VUE_APP_REST_API_VSMS
baseURL = baseURL[baseURL.length] === '/' ? baseURL.slice(0, -1) : baseURL

const _get = async (queryParamFilters, queryParam) => {
  queryParamFilters.push('parent_only = true')

  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParamFilters || undefined,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/vehicle',
    params: params,
  })

  return response?.data
}

export const get = (queryParamFilters) => async (queryParam) =>
  await _get(queryParamFilters, queryParam)

export const getBoxType = async (queryParam) => {
  const filters = Array.isArray(queryParam?.filters)
    ? queryParam.filters
    : queryParam?.filters
    ? [queryParam.filters]
    : undefined

  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: filters,
  }

  const response = await apiClient({
    baseURL,
    method: 'GET',
    url: '/box-type',
    params: params,
  })

  return response?.data
}


export const getVehicleGroup  = async (queryParam) => {
  const filters = Array.isArray(queryParam?.filters)
    ? queryParam.filters
    : queryParam?.filters
    ? [queryParam.filters]
    : undefined

  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: filters,
  }

  const response = await apiClient({
    baseURL,
    method: 'GET',
    url: '/vgroup',
    params: params,
  })

  return response?.data
}

export const getVehicleType = async (queryParam) => {
  const filters = Array.isArray(queryParam?.filters)
    ? queryParam.filters
    : queryParam?.filters
    ? [queryParam.filters]
    : undefined

  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: filters,
  }

  const response = await apiClient({
    baseURL,
    method: 'GET',
    url: '/vehicle/type',
    params: params,
  })

  return response?.data
}
